export default __webpack_public_path__ + "static/media/4.b076c0d7.jpg";